/**
 * Cart Celebration Animation
 * Animación de celebración al agregar productos al carrito
 * Compatible con el tema Dawn de Shopify
 */

(function() {
  'use strict';

  // Inyectar estilos CSS
  const styles = `
    .flying-image {
      position: fixed;
      pointer-events: none;
      z-index: 9999;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      transition: none;
    }

    @keyframes cartBounce {
      0% { transform: scale(1); }
      20% { transform: scale(1.3); }
      40% { transform: scale(0.9); }
      60% { transform: scale(1.1); }
      80% { transform: scale(0.95); }
      100% { transform: scale(1); }
    }

    .cart-icon--bouncing {
      animation: cartBounce 0.6s ease-out;
    }

    @keyframes checkmarkPop {
      0% { transform: scale(0); opacity: 0; }
      50% { transform: scale(1.2); }
      100% { transform: scale(1); opacity: 1; }
    }

    .button--success {
      background: #10B981 !important;
      background-color: #10B981 !important;
      border-color: #10B981 !important;
      color: white !important;
      transition: background-color 0.3s ease, border-color 0.3s ease;
    }

    .button--success .checkmark {
      display: inline-block;
      animation: checkmarkPop 0.4s ease-out;
    }

    /* Respeta prefers-reduced-motion */
    @media (prefers-reduced-motion: reduce) {
      .flying-image,
      .cart-icon--bouncing,
      .button--success .checkmark {
        animation: none !important;
        transition: none !important;
      }
    }
  `;

  // Inyectar estilos en el head
  function injectStyles() {
    if (document.getElementById('cart-celebration-styles')) return;

    const styleSheet = document.createElement('style');
    styleSheet.id = 'cart-celebration-styles';
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
  }

  // Verificar si el usuario prefiere movimiento reducido
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Obtener el icono del carrito
  function getCartIcon() {
    return document.querySelector('.header__icon--cart') ||
           document.querySelector('#cart-icon-bubble') ||
           document.querySelector('[href*="/cart"]');
  }

  // Obtener la imagen del producto
  function getProductImage() {
    return document.querySelector('.product__media img') ||
           document.querySelector('.product-media img') ||
           document.querySelector('.product__media-item img') ||
           document.querySelector('[class*="product"] img[src*="cdn.shopify"]');
  }

  // Obtener el botón de agregar al carrito
  function getAddToCartButton() {
    return document.querySelector('button[name="add"]') ||
           document.querySelector('.product-form__submit') ||
           document.querySelector('[type="submit"][name="add"]');
  }

  // Animación de imagen voladora
  function flyImageToCart(productImage, cartIcon) {
    if (prefersReducedMotion() || !productImage || !cartIcon) return;

    const imgRect = productImage.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();

    // Clonar la imagen
    const flyingImg = productImage.cloneNode(true);
    flyingImg.className = 'flying-image';
    flyingImg.style.cssText = `
      position: fixed;
      left: ${imgRect.left}px;
      top: ${imgRect.top}px;
      width: ${imgRect.width}px;
      height: ${imgRect.height}px;
      object-fit: cover;
      pointer-events: none;
      z-index: 9999;
    `;

    document.body.appendChild(flyingImg);

    // Calcular posición destino (centro del icono del carrito)
    const destX = cartRect.left + (cartRect.width / 2) - (imgRect.width * 0.1);
    const destY = cartRect.top + (cartRect.height / 2) - (imgRect.height * 0.1);

    // Animar con requestAnimationFrame para mejor rendimiento
    const duration = 700;
    const startTime = performance.now();
    const startX = imgRect.left;
    const startY = imgRect.top;

    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOut(progress);

      const currentX = startX + (destX - startX) * eased;
      const currentY = startY + (destY - startY) * eased;
      const scale = 1 - (0.8 * eased); // De 1 a 0.2
      const opacity = 1 - (0.3 * eased); // Reducir opacidad gradualmente

      flyingImg.style.left = `${currentX}px`;
      flyingImg.style.top = `${currentY}px`;
      flyingImg.style.transform = `scale(${scale})`;
      flyingImg.style.opacity = opacity;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Remover imagen voladora y disparar bounce del carrito
        flyingImg.remove();
        bounceCartIcon(cartIcon);
      }
    }

    requestAnimationFrame(animate);
  }

  // Animación bounce del icono del carrito
  function bounceCartIcon(cartIcon) {
    if (prefersReducedMotion() || !cartIcon) return;

    cartIcon.classList.remove('cart-icon--bouncing');
    // Forzar reflow para reiniciar la animación
    void cartIcon.offsetWidth;
    cartIcon.classList.add('cart-icon--bouncing');

    setTimeout(() => {
      cartIcon.classList.remove('cart-icon--bouncing');
    }, 600);
  }

  // Cambiar estado del botón a éxito
  function showButtonSuccess(button) {
    if (!button) return;

    const originalText = button.innerHTML;
    const originalClasses = button.className;

    button.classList.add('button--success');
    button.innerHTML = '<span class="checkmark">✓</span> ¡Agregado!';

    setTimeout(() => {
      button.classList.remove('button--success');
      button.innerHTML = originalText;
    }, 2000);
  }

  // Celebración completa
  function triggerCelebration() {
    const productImage = getProductImage();
    const cartIcon = getCartIcon();
    const addButton = getAddToCartButton();

    // Si hay reducción de movimiento, solo cambiar texto del botón
    if (prefersReducedMotion()) {
      showButtonSuccess(addButton);
      return;
    }

    // Disparar animación de imagen voladora
    flyImageToCart(productImage, cartIcon);

    // Mostrar éxito en el botón
    showButtonSuccess(addButton);

    // Si no hay imagen, solo hacer bounce del carrito
    if (!productImage) {
      setTimeout(() => bounceCartIcon(cartIcon), 100);
    }
  }

  // Interceptar el fetch a /cart/add.js
  function interceptCartFetch() {
    const originalFetch = window.fetch;

    window.fetch = function(...args) {
      const url = args[0];

      // Verificar si es una llamada a agregar al carrito
      if (typeof url === 'string' && url.includes('/cart/add')) {
        return originalFetch.apply(this, args)
          .then(response => {
            // Clonar la respuesta para poder leerla
            const clonedResponse = response.clone();

            if (response.ok) {
              // Disparar celebración con un pequeño delay para mejor UX
              setTimeout(triggerCelebration, 100);
            }

            return response;
          });
      }

      return originalFetch.apply(this, args);
    };
  }

  // Interceptar submit del formulario de producto
  function interceptFormSubmit() {
    document.addEventListener('submit', function(event) {
      const form = event.target;

      // Verificar si es un formulario de producto
      if (form.action && form.action.includes('/cart/add')) {
        // Si el formulario usa AJAX (theme Dawn), la celebración se maneja via fetch
        // Si no, disparar celebración directamente
        if (!form.hasAttribute('data-ajax')) {
          setTimeout(triggerCelebration, 500);
        }
      }
    }, true);
  }

  // Escuchar eventos personalizados de Shopify/Dawn
  function listenToShopifyEvents() {
    // Evento de Dawn cuando se agrega al carrito exitosamente
    document.addEventListener('cart:item-added', triggerCelebration);

    // Variantes del evento
    document.addEventListener('ajaxProduct:added', triggerCelebration);
    document.addEventListener('product:added', triggerCelebration);
  }

  // Inicializar
  function init() {
    injectStyles();
    interceptCartFetch();
    interceptFormSubmit();
    listenToShopifyEvents();

    console.log('[Cart Celebration] Inicializado correctamente');
  }

  // Esperar a que el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
